export enum ActionType {
  TOGGLE_LANGUAGE = 'TOGGLE_LANGUAGE',
}

interface ToggleLanguage {
  type: ActionType.TOGGLE_LANGUAGE;
}

export type Action = ToggleLanguage;
